import React, {
  ReactElement, useEffect, useRef, useState,
} from 'react';
import { useLocation, useParams } from 'react-router';
import {
  Col, InsetText, Link, Row,
} from 'idsk-react-components';
import LegislativnyMaterialDetail
  from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import { useUserContext } from '../../../context/UserContext';
import { pouzivatelIsAdmin } from '../../../function/permissions';
import StadiumMaterialuSelect from '../component/StadiumMaterialuSelect';
import Secured from '../../Secured';
import routes from '../../../routing/routes';
import DownloadSprievodnyDokumentListButton
  from '../component/DownloadSprievodnyDokumentListButton';
import SprievodnyDokumentUpdateListComponent
  from './component/SprievodnyDokumentUpdateListComponent';
import errorIcon from '../../../../assets/images/icon-error-red.svg';
import { getInitialStadium, isLatestStadium } from '../../../function/getLatestStadium';
import StadiumMaterialuHistoriaList
  from '../../../model/legislativnyMaterial/StadiumMaterialuHistoriaList';
import './sprievodnyDokumentUpdateList.scss';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
  legMaterialHistoriaList: StadiumMaterialuHistoriaList;
}

const SprievodnyDokumentUpdateList = ({
  materialDetail,
  legMaterialHistoriaList,
}: Props): ReactElement => {
  const { search } = useLocation();
  const stadiumUuidSearchParam = new URLSearchParams(search).get('stadiumUuid');
  const [selectedStadium, setSelectedStadium] = useState(
    getInitialStadium(legMaterialHistoriaList, stadiumUuidSearchParam),
  );
  const [documentsExists, setDocumentsExists] = useState<boolean>(false);
  const { pouzivatel } = useUserContext();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const stickyElement = useRef<HTMLDivElement>();
  const [startingOffset, setStartingOffset] = useState<number>(0);

  useEffect(() => {
    if (stickyElement.current !== undefined) {
      setStartingOffset(stickyElement.current.offsetTop);
    }
  }, []);

  return (
    <div className="sprievodny-dokument-list">
      {!isLatestStadium(legMaterialHistoriaList, selectedStadium) && (
        <Row>
          <Col>
            <div className="sticky-element" data-offset={startingOffset} ref={stickyElement}>
              <InsetText
                type="warn"
                className="non-actual-sprievodny-dokument-list__message"
                icon={errorIcon}
              >
                Prezeráte si neaktuálnu (archívnu) verziu dokumentov.
              </InsetText>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col width={(pouzivatelIsAdmin(pouzivatel) && documentsExists) ? 'one-third' : 'one-half'}>
          <StadiumMaterialuSelect
            materialDetail={materialDetail}
            selectedStadium={selectedStadium}
            setSelectedStadium={setSelectedStadium}
            legMaterialHistoriaList={legMaterialHistoriaList}
          />
        </Col>
        <Secured additionalCheck={pouzivatelIsAdmin(pouzivatel)}>
          <Col width="one-third">
            {documentsExists && (
              <Link
                to={routes.procesy.detail.sprievodneDokumenty.editOrder.withParams(
                  type,
                  year,
                  index,
                  selectedStadium.uuid,
                )}
                type="button-third"
                size="large"
                className="sprievodny-dokument-list-sort-button"
              >
                <span className="sprievodny-dokument-list-sort-icon" />
                <div>Zmeniť poradie dokumentov</div>
              </Link>
            )}
          </Col>
        </Secured>
        <Col width={(pouzivatelIsAdmin(pouzivatel) && documentsExists) ? 'one-third' : 'one-half'}>
          {documentsExists && (
            <DownloadSprievodnyDokumentListButton
              legMaterialUuid={materialDetail.uuid}
              stadiumUuid={selectedStadium.uuid}
            />
          )}
        </Col>
      </Row>
      {selectedStadium?.uuid && (
        <SprievodnyDokumentUpdateListComponent
          materialDetail={materialDetail}
          selectedStadium={selectedStadium}
          setDocumentsExists={setDocumentsExists}
        />
      )}
    </div>
  );
};

export default SprievodnyDokumentUpdateList;
